export default __webpack_public_path__ + "static/media/2075.35c23e86.png";